import { FORGOT_PASSWORD } from "../apis/_index";
import ServiceUtils from "../utils/services";

export const ForgotPassword = (body: any) => {
    return new Promise(async resolve => {
        return await ServiceUtils.postV2(FORGOT_PASSWORD, body)
            .then((res: any) => {

                resolve({
                    status: true,
                    data: res
                });
            })
            .catch((err: any) => {
                resolve({
                    status: false,
                    err: err
                });
            })
    })
}